import {Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {DialogModule} from 'primeng/dialog';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {ButtonModule} from 'primeng/button';
import Swal from 'sweetalert2';
import {Archivo, ItemDeleteReq} from "../../../../../officials/archivos/interfaces/archivos.interfaces";
import {ArchviosService} from "../../../../../officials/archivos/services/archivos.service";
import {NgIf} from "@angular/common";
import {FloatLabelModule} from "primeng/floatlabel";

@Component({
    selector: 'app-eliminar-archivo-dlg',
    standalone: true,
    imports: [FormsModule, DialogModule, InputTextareaModule, ButtonModule, NgIf, FloatLabelModule],
    templateUrl: 'eliminar-archivo-dlg.component.html',
})
export class EliminarArchivoDlgComponent {
    private svc = inject(ArchviosService);
    @Input() visible = false;
    @Output() visibleChange = new EventEmitter<boolean>();
    @Input({required: true}) archivo!: Archivo | null;
    @Output() deleted = new EventEmitter<boolean>();
    comentarios = '';
    deleting = false;

    confirm(): void {
        if (!this.archivo) return;
        const req: ItemDeleteReq = {
            idProyecto: this.archivo.idProyecto!,
            hash: this.archivo.hash!,
            comentarios: this.comentarios?.trim() || undefined,
        };
        this.deleting = true;
        this.svc.eliminar(req).subscribe({
            next: () => {
                this.deleting = false;
                this.visibleChange.emit(false);
                this.deleted.emit(true);
                this.comentarios = '';
                Swal.fire({icon: 'success', title: 'Eliminado', text: 'El archivo fue eliminado correctamente.'});
            },
            error: (err) => {
                this.deleting = false;
                this.cancel()
                Swal.fire({
                    icon: 'error',
                    title: 'No se pudo eliminar',
                    text: err?.error?.message || 'Ocurrió un error. Inténtalo de nuevo.',
                });
            },
        });
    }

    cancel(): void {
        if (this.deleting) return;
        this.visibleChange.emit(false);
        this.comentarios = '';
    }
}
